import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import { TrustPilotLocale } from '/@/modules/trustpilot/constants/TrustPilotLocale';
import { TrustPilotUrl } from '/@/modules/trustpilot/constants/TrustPilotUrl';
import { TrustPilotWidgetType } from '/@/modules/trustpilot/constants/TrustPilotWidgetType';
import { TrustPilotWidgetSetup } from '/@/modules/trustpilot/constants/TrustPilotWidgetSetup';
import Lang from '/@/modules/core/app/services/Lang';

export const LoadTrustPilotWidgetMixin = {
  static: {
    TrustPilotWidgetSetup,
    TrustPilotLocale,
    TrustPilotUrl,
    TrustPilotWidgetType
  },
  data() {
    return {
      isLoadingTrustPilotWidget: true
    };
  },
  computed: {
    trustpilotLocale() {
      return Lang.isFrench() ? TrustPilotLocale.FR_CA : TrustPilotLocale.EN_CA;
    }
  },
  methods: {
    loadInitialTrustpilotWidget() {
      if (document.getElementById(TrustPilotWidgetSetup.SCRIPT_ELEMENT_ID)) {
        this.isLoadingTrustPilotWidget = false;

        return;
      }

      this.appendTrustPilotWidgetBootstrapScriptTag();
    },
    appendTrustPilotWidgetBootstrapScriptTag() {
      DocumentUIService.addDynamicScript(
        TrustPilotWidgetSetup.SCRIPT_ELEMENT_ID,
        TrustPilotUrl.BOOTRSTAP_WIDGET_URL,
        {
          onload: () => this.onScriptLoad()
        }
      );
    },
    onScriptLoad() {
      this.isLoadingTrustPilotWidget = false;
    },
    loadWidgetIfScriptLoaded() {
      const widget = document.querySelector('.trustpilot-widget');
      if (window.Trustpilot && widget) {
        window.Trustpilot.loadFromElement(widget);
      }
    }
  },
  created() {
    this.loadInitialTrustpilotWidget();
  },
  mounted() {
    // Need to re-run the `loadFromElement` method when component is remounted
    this.loadWidgetIfScriptLoaded();
  }
};
